import CheckRedirect from "@/utils/check-redirect";
import { LICENSE_CODE_QUERY_PARAM } from "../components/license-redemption/license-dialog";

const AccountRedirectCheckFunction = (searchString: string) => searchString.includes(LICENSE_CODE_QUERY_PARAM); 
export const AccountRedirectCheck = CheckRedirect({ checks: [{ includeSearch: true, check: AccountRedirectCheckFunction, redirectTo: "/licenses"}]});
export default AccountRedirectCheck;
